export type MetaInfoType = {title: string, meta?: {name: string, content: string}[]}
export const setMetaInfo = (data: MetaInfoType) => {
    document.title = data.title+" | Louisiana Department of Education";
}